import { Product } from 'constants/products';
import locator from 'utils/locator';
import { getPageType } from 'utils/get-page-type';
import concatenatePromotionValues from '../../utilities/concatenate-promotion-values';

const QUICK_SHOP_LABEL = 'Quick Shop Regulars';
const EVENT_NAME = 'view_item_list';

const viewItemList = (
  state: WtrState,
  action: {
    payload: {
      suggestions: Product[];
    };
  },
) => {
  const pageType = getPageType(locator.pathname);
  const { suggestions } = action.payload;
  const { products } = state.entities;

  const items = suggestions.map(({ lineNumber }, index) => {
    const { name, id, weights, pricing, currentSaleUnitPrice } = products[lineNumber];
    const offer = concatenatePromotionValues(state, pricing.promotions) || '';

    return {
      currencyCode: 'GBP',
      id: lineNumber,
      list: pageType,
      name,
      offer,
      position: index + 1,
      price: currentSaleUnitPrice.price.amount || '',
      product_sku: id,
      uom: weights.uoms[0],
      product_finding_method: QUICK_SHOP_LABEL,
      item_list_name: QUICK_SHOP_LABEL,
    };
  });

  return {
    event: EVENT_NAME,
    ecommerce: {
      currencyCode: 'GBP',
      product_finding_method: QUICK_SHOP_LABEL,
      item_list_name: QUICK_SHOP_LABEL,
      items,
    },
  };
};

export default viewItemList;
